import { Route, Routes, Navigate } from 'react-router-dom'
import Home from 'views/Home/Home'
import Login from 'views/Login/Login'
import RoutePlanning from 'views/RoutePlanning/RoutePlanning'
import { Places } from 'views/Places/Places'
import { PlaceInfo } from 'views/Place/PlaceInfo'
import { PlaceExtension } from 'views/Place/PlaceExtension'
import { PlaceContact } from 'views/Place/PlaceContact'
import { PlaceFulfilment } from 'views/Place/PlaceFulfilment'
import { OrderProduct } from 'views/OrderProduct/OrderProduct'
import { OrderFulfilment } from 'views/Order/OrderFulfilment'
import { OrderActivity } from 'views/OrderActivity/OrderActivity'
import { PlacesSelection } from 'views/RoutePlanning/PlacesSelection'
import { SearchConfig } from 'views/SearchConfig/SearchConfig'
import { Orders } from 'views/Orders/Orders'
import { OrderInfo } from 'views/Order/OrderInfo'
import { ServiceAreaWrapper } from 'views/ServiceAreas/ServiceAreas'
import { ProductDescriptiveInfo } from 'views/Product/ProductDescriptiveInfo'
import { ProductSalesInfo } from 'views/Product/ProductSalesInfo'
import { ProductSearchSettings } from 'views/Product/ProductSearchSettings'
import { AdditionalInfo } from 'views/Product/AdditionalInfo'
import { ProductPackagingInfo } from 'views/Product/ProductPackagingInfo'
import { ProductNutritionalInfo } from 'views/Product/ProductNutritionalInfo'
import { RelatedProducts } from 'views/Product/RelatedProducts'
import { ProductRawData } from 'views/Product/ProductRawData'
import Order from 'views/Order/Order'
import { Products } from 'views/Products/Products'
import { Product } from 'views/Product/Product'
import { PlacePayment } from 'views/Place/PlacePayment'
import { ROUTES, SIDEBARROUTES, PLACEMAINROUTES, PRODUCTROUTES } from './routes'
import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'

const RouteLinks = () => {
  return (
    <Routes>
      {/* Public Routes will not be accessible once user is logged in */}
      <Route path={ROUTES.LOGIN} element={<PublicRoute />}>
        <Route index element={<Login />} />
      </Route>
      {/* Private Routes will not be accessible once user is not logged in */}
      <Route path={ROUTES.DASHBOARD} element={<PrivateRoute />}>
        <Route index element={<Home />} />
      </Route>

      <Route path={PLACEMAINROUTES.INFO} element={<PrivateRoute />}>
        <Route index element={<PlaceInfo />} />
      </Route>

      <Route path={PLACEMAINROUTES.CONTACT} element={<PrivateRoute />}>
        <Route index element={<PlaceContact />} />
      </Route>

      <Route path={PLACEMAINROUTES.FULFILMENT} element={<PrivateRoute />}>
        <Route index element={<PlaceFulfilment />} />
      </Route>

      <Route path={PLACEMAINROUTES.PAYMENT} element={<PrivateRoute />}>
        <Route index element={<PlacePayment />} />
      </Route>

      <Route path={PLACEMAINROUTES.DATA_EXTENSION} element={<PrivateRoute />}>
        <Route index element={<PlaceExtension />} />
      </Route>

      <Route path={PLACEMAINROUTES.SERVICEAREAS} element={<PrivateRoute />}>
        <Route index element={<ServiceAreaWrapper />} />
      </Route>

      <Route path={ROUTES.ORDER} element={<PrivateRoute />}>
        <Route element={<Order />}>
          <Route path={ROUTES.ORDER_INFO} element={<OrderInfo />} />
          <Route path={ROUTES.ORDER_FULFILMENT} element={<OrderFulfilment />} />
          <Route path={ROUTES.ORDER_PRODUCT} element={<OrderProduct />} />
          <Route path={ROUTES.ORDER_ACTIVITY} element={<OrderActivity />} />
        </Route>
      </Route>

      <Route path={PRODUCTROUTES.PRODUCT} element={<PrivateRoute />}>
        <Route element={<Product />}>
          <Route
            path={PRODUCTROUTES.DESCRIPTIVE_INFO}
            element={<ProductDescriptiveInfo />}
          />
          <Route
            path={PRODUCTROUTES.SALES_INFO}
            element={<ProductSalesInfo />}
          />
          <Route
            path={PRODUCTROUTES.SEARCH_SETTINGS}
            element={<ProductSearchSettings />}
          />
          <Route
            path={PRODUCTROUTES.PACKAGING_INFO}
            element={<ProductPackagingInfo />}
          />
          <Route
            path={PRODUCTROUTES.NUTRITIONAL_INFO}
            element={<ProductNutritionalInfo />}
          />
          <Route
            path={PRODUCTROUTES.ADDITIONAL_INFO}
            element={<AdditionalInfo />}
          />
          <Route
            path={PRODUCTROUTES.RELATED_PRODUCTS}
            element={<RelatedProducts />}
          />
          <Route path={PRODUCTROUTES.RAW_DATA} element={<ProductRawData />} />
        </Route>
      </Route>

      <Route path={SIDEBARROUTES.ROUTE} element={<PrivateRoute />}>
        <Route index element={<PlacesSelection />} />

        <Route path={ROUTES.SELECTED_ROUTE} element={<RoutePlanning />} />
      </Route>

      <Route path={SIDEBARROUTES.ORDER} element={<PrivateRoute />}>
        <Route index element={<Orders />} />
      </Route>

      <Route path={SIDEBARROUTES.PLACE} element={<PrivateRoute />}>
        <Route index element={<Places />} />
      </Route>

      <Route path={SIDEBARROUTES.PRODUCT} element={<PrivateRoute />}>
        <Route index element={<Products />} />
      </Route>

      <Route path={SIDEBARROUTES.SEARCH} element={<PrivateRoute />}>
        <Route index element={<SearchConfig />} />
      </Route>

      <Route path='*' element={<Navigate to={ROUTES.DASHBOARD} replace />} />
    </Routes>
  )
}

export default RouteLinks
